import { createSelector } from 'reselect';
import { getProfileOptions } from './EntitySelector';
export const getLanguagesToDefaultLocales = createSelector([getProfileOptions], profileOptions => profileOptions.get('languageOptions').reduce((acc, option) => {
  acc[option.get('language')] = option.get('defaultLocale');
  return acc;
}, {}));
export const getSupportsSignature = createSelector([getProfileOptions], profileOptions => profileOptions.get('supportsSignature'));